import { render, staticRenderFns } from "./InstallationDateBanner.vue?vue&type=template&id=c15f43ba&scoped=true"
import script from "./InstallationDateBanner.vue?vue&type=script&lang=ts"
export * from "./InstallationDateBanner.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c15f43ba",
  null
  
)

export default component.exports